/**
 * Created by Ivan on 05.02.2026
 */

KingsCupStartWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        const styles = cleverapps.styles.KingsCupStartWindow;

        this.mission = mission;

        this._super({
            name: "KingsCupStartWindow",
            title: Messages.get("Missions.KingsCup.Title"),
            content: this.createContent(mission),
            notCloseByTouchInShadow: true,
            closeButtonDelay: true,
            button: {
                width: styles.button.width,
                height: styles.button.height,
                text: this.getButtonText(mission),
                onPressed: this.onPressed.bind(this)
            },
            help: () => GuideWindow.createMissionRulesWindow(mission),
            styles: styles.window,
            timer: mission.getTimeLeft()
        });
    },

    onPressed: function () {
        cleverapps.missionManager.trigger("kingsCupStart", this.mission);
        this.close();
    },

    createContent: function (mission) {
        const styles = cleverapps.styles.KingsCupStartWindow;

        const picture = new cc.Sprite(bundles.kingscup_start_window.frames.picture);

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get(this.chooseText(mission)), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setDimensions(styles.text.width, 0);
        text.fitTo(undefined, styles.text.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        return new cleverapps.Layout([picture, text], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });
    },

    chooseText: function (mission) {
        let key = `${mission.name}StartWindow.descriptionUnlocked`;

        if (!mission.isUnlocked()) {
            key = mission.logic.ready
                ? `${mission.name}StartWindow.descriptionReady`
                : `${mission.name}StartWindow.descriptionNotReady`;
        }

        if (!cleverapps.config.features.includes("lives") && Messages.has(`${key}NoLives`)) {
            key += "NoLives";
        }

        return key;
    },

    getButtonText: function (mission) {
        return Messages.get(`KingsCupStartWindow.Button.${mission.logic.ready ? "" : "Not"}Ready`);
    },

    listBundles: function () {
        return ["kingscup_start_window"];
    }
});

cleverapps.styles.KingsCupStartWindow = {
    margin: 20,
    text: {
        width: 640,
        height: 300
    },
    button: {
        width: 300,
        height: 105
    },
    timer: {
        width: 320,
        height: 0,
        margin: 20,
        padding: {
            x: 10
        },
        layout: {
            x: { align: "left", dx: -20 },
            y: { align: "center" }
        },
        position: [
            { x: { align: "center" }, y: { align: "bottom", dy: -245 } },
            { x: { align: "center" }, y: { align: "bottom", dy: -242 } },
            { x: { align: "center" }, y: { align: "bottom", dy: -242 } }
        ]
    }
};
